import { FC } from 'react';
import cn from 'classnames';
import { useParams } from 'react-router-dom';
import { Box, InputLabel, SelectChangeEvent, SelectProps } from '@mui/material';

import { SelectStyled, MenuItemStyled } from '../Filters/styles';
import {
  LinkManagementStatus,
  LinkManagementStatusMapper,
} from '@organisms/Tables/Enterprise/LinksReviewTable/types';
import { useEditMultipleLinksReview } from '@organisms/Tables/Enterprise/LinksReviewTable/api/edit-multiple-links-review';

interface Props extends SelectProps {
  value?: LinkManagementStatus | null | 'mixed';
  links: string[];
}

export const LinkReviewStatusSelect: FC<Props> = ({ value, links, className, ...props }) => {
  const { id: companyId } = useParams();
  const { mutate: editLinks } = useEditMultipleLinksReview();

  const handleOnChange = (event: SelectChangeEvent<unknown>) => {
    event.stopPropagation();
    editLinks({
      companyId: companyId as string,
      data: {
        ids: links,
        status: event.target.value as LinkManagementStatus,
      },
    });
  };

  return (
    <Box display="flex" alignItems="center">
      <InputLabel sx={{ marginBottom: '0' }}>Status: </InputLabel>
      <SelectStyled
        placeholder="Select option"
        sx={{ width: '220px', height: '40px' }}
        value={value}
        onChange={handleOnChange}
        className={cn(className, 'small')}
        {...props}
      >
        {Object.entries(LinkManagementStatus).map(([, key]: [string, LinkManagementStatus]) => {
          return (
            <MenuItemStyled key={key} value={key}>
              {LinkManagementStatusMapper[key]}
            </MenuItemStyled>
          );
        })}
        {value === 'mixed' && <MenuItemStyled value="mixed">Mixed</MenuItemStyled>}
      </SelectStyled>
    </Box>
  );
};
